import { Form } from 'antd';
import TcFormWrapper from 'components/UI/FormWrapper/TcFormWrapper';
import TcModal from 'components/UI/Modal/TcModal';
import TcButton from 'components/UI/button/TcButton';
import TcForm from 'components/UI/form/TcForm';
import TcCoverLoading from 'components/UI/loading/TcCoverLoading';
import endpointUrls from 'global/Constants/endpointUrls';
import branchCustomerProductTypeModel from 'global/Models/branchCustomerProductTypeModel';
import { handleApiThen } from 'global/helperFunctions/handleApiThen';
import { localApiCatcher } from 'global/helperFunctions/localApiCatcher';
import ApiService, { errorResponse } from 'global/utils/ApiService';
import { FC, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { getCustomerProductTypes } from 'redux/reducer/ParcelOrder/getCustomerProductTypes';
import { RootState, store } from 'redux/store';

interface ProductTypeCreateModalProps {
  visible: boolean;
  close(): void;
  refetch(): void;
}

const BranchCustomerProductCreate: FC<ProductTypeCreateModalProps> = ({ visible, close, refetch }) => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const { customerUser } = useSelector((state: RootState) => state.user);
  const customerId = useMemo(() => customerUser?.customerId, [customerUser?.customerId]);
  const handleClose = () => {
    form.resetFields();
    close();
  };

  useEffect(() => {
    store.dispatch(getCustomerProductTypes());
  }, []);
  const handleSubmit = async (values: Record<string, any>) => {
    setLoading(true);
    await ApiService.post(endpointUrls.branchCustomerProductCreate, { ...values, fCustomerId: customerId || 0 })
      .then((res: any) =>
        handleApiThen({
          res,
          notifFail: true,
          notifSuccess: true,
          onSuccess: () => {
            refetch();
            handleClose();
          },
        })
      )
      .catch(() => localApiCatcher(errorResponse));
    setLoading(false);
  };

  return (
    <TcModal title='ایجاد نوع کالا' width={520} onCancel={handleClose} visible={visible} footer={false} destroyOnClose>
      <TcForm form={form} layout='vertical' onFinish={handleSubmit}>
        <TcFormWrapper>{branchCustomerProductTypeModel.inputs()}</TcFormWrapper>
        <TcButton className='w-full mt-6' type='primary' htmlType='submit' loading={loading}>
          ثبت نوع کالا در انبار
        </TcButton>
      </TcForm>
      {loading && <TcCoverLoading />}
    </TcModal>
  );
};

export default BranchCustomerProductCreate;
